module.exports = __webpack_public_path__ + "media/images/icons/calendar-a2b3b6375e5bf19d39109d69c4c2f045.svg";